export default __webpack_public_path__ + "static/media/home-image3.4662fc19.jpg";